import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "field"]
  static values = {
    max: { type: Number, default: 3 }
  }

  connect() {
    this.updateButtons()
  }

  addField(event) {
    event.preventDefault()

    const fieldCount = this.fieldTargets.length
    if (fieldCount >= this.maxValue) {
      return
    }

    const fieldType = event.currentTarget.dataset.fieldType
    const template = this.getFieldTemplate(fieldType)

    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = template
    const newField = tempDiv.firstElementChild

    this.containerTarget.appendChild(newField)
    this.updateButtons()
  }

  removeField(event) {
    event.preventDefault()

    const field = event.currentTarget.closest('[data-dynamic-fields-target="field"]')
    if (field && this.fieldTargets.length > 1) {
      field.remove()
      this.updateButtons()
    }
  }

  previewPhoto(event) {
    const input = event.currentTarget
    const file = input.files[0]
    const field = input.closest('[data-dynamic-fields-target="field"]')

    const existing = field.querySelector('.photo-preview')
    if (existing) existing.remove()

    if (!file) return

    const preview = document.createElement('div')
    preview.className = 'photo-preview mb-2'

    if (file.type.startsWith('image/')) {
      const img = document.createElement('img')
      img.className = 'rounded'
      img.style.cssText = 'max-height: 80px; max-width: 100%; display: block;'

      const reader = new FileReader()
      reader.onload = (e) => { img.src = e.target.result }
      reader.readAsDataURL(file)

      preview.appendChild(img)
    } else {
      preview.innerHTML = `<span class="text-muted small"><i class="bi bi-file-earmark me-1"></i>${file.name}</span>`
    }

    field.appendChild(preview)
  }

  updateButtons() {
    const fieldCount = this.fieldTargets.length
    const removeButtons = this.element.querySelectorAll('[data-action*="removeField"]')

    removeButtons.forEach(button => {
      button.disabled = fieldCount <= 1
    })

    const addButton = this.element.querySelector('[data-action*="addField"]')
    if (addButton) {
      addButton.disabled = fieldCount >= this.maxValue
    }
  }

  getFieldTemplate(fieldType) {
    if (fieldType === 'phone') {
      return `
        <div class="mb-3" data-dynamic-fields-target="field">
          <div class="input-group" data-controller="phone-number">
            <input class="form-control" type="tel" name="client_registration[phone_numbers][]" placeholder="Phone number" data-phone-number-target="phone" required="required">
            <button class="btn btn-outline-danger" type="button" data-action="click->dynamic-fields#removeField">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>
      `
    } else if (fieldType === 'email') {
      return `
        <div class="input-group mb-2" data-dynamic-fields-target="field">
          <input class="form-control" type="email" name="client_registration[emails][]" placeholder="Email address" required="required">
          <button class="btn btn-outline-danger" type="button" data-action="click->dynamic-fields#removeField">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      `
    } else if (fieldType === 'photo') {
      return `
        <div data-dynamic-fields-target="field">
          <div class="input-group mb-1">
            <input class="form-control" type="file" name="photos[]" accept="image/*,application/pdf" data-action="change->dynamic-fields#previewPhoto">
            <button class="btn btn-outline-danger" type="button" data-action="click->dynamic-fields#removeField">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>
      `
    }
  }
}
